import store from "@/store"

export default function onlySuperadmin({ next, router }) {
    if(!store || !store.state.auth.isLogged || !['superadmin'].includes(store.state.auth.user.role)) {
        router.push('/admin/login')
        return
    }
    return next()
}
